import { render } from "./PvpHeader.vue?vue&type=template&id=74f428fa"
import script from "./PvpHeader.vue?vue&type=script&lang=ts"
export * from "./PvpHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script